import { render } from "./settings.vue?vue&type=template&id=8ba8390a"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"
script.render = render

export default script